import { render, staticRenderFns } from "./InsuranceDetailSummary.vue?vue&type=template&id=c01b30be&functional=true&"
import script from "./InsuranceDetailSummary.vue?vue&type=script&lang=js&"
export * from "./InsuranceDetailSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports